import styled from "styled-components";
import theme from "../../theme";
import {
  DistributionStatusEnum,
  DistributionStatus,
} from "../../enums/DistributionStatus";

const Container = styled.div<{
  $showSelection: boolean;
}>`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;

  span {
    font-size: 14px;
    font-weight: 700;
    color: ${theme.textDark};
  }

  > span:nth-child(2) {
    margin-bottom: 20px;
  }

  strong {
    font-size: 16px;
    font-weight: 700;
    color: ${theme.textDark};
  }

  small {
    font-size: 16px;
    font-weight: 400;
    color: ${theme.textDark};
  }

  img {
    width: 65px;
    height: 65px;
  }

  ul {
    list-style-type: none;
    width: 100%;
    margin-top: 20px;

    li + li {
      border-top: 1px solid #ccc;
    }

    li:last-child {
      padding-bottom: 0;
    }

    li {
      display: flex;
      align-items: center;
      padding: 5px 0;
      flex-wrap: wrap;

      & > div:first-child {
        width: 35px;
        align-self: flex-start;
      }

      div:nth-child(2) {
        display: flex;
        flex-direction: column;

        small {
          font-size: 12px;
          font-weight: 400;
          color: #1f1f1f;
        }
      }
      div:nth-child(3) {
        margin-left: auto;
        display: flex;
        align-items: center;

        div:nth-child(1) {
          flex-shrink: 0;
          width: 100px;
          height: 24px;
          border-radius: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          font-size: 10px;
          font-weight: 700;
          color: #1f1f1f;
        }
        svg {
          cursor: pointer;
          padding-left: 20px;
        }
      }
    }
  }

  button {
    width: 100%;
    margin-top: 20px;
  }
`;

const TotalAmount = styled.div`
  svg {
    width: 14px;
    height: 14px;
  }

  span {
    font-size: 16px;
    font-weight: 900;
    color: ${theme.textDark};
    margin-left: 2px;
  }
`;

const DistributionStatusStyle = styled.div<{
  $status: DistributionStatusEnum;
}>`
  background-color: ${({ $status }) =>
    DistributionStatus.getStatusBgColor($status)};
`;

export {
  Container,
  TotalAmount,
  DistributionStatusStyle as DistributionStatus,
};
